export const AMOUNT_EFUN_FER_CHANCE = 1000;
export const MAXIMUM_OPTIONS_PREDICT = 2;

export const ASYNC_STORAGE_KEYS = {
  TOKEN: "TOKEN",
  USER: "USER",
  RESET_TIME: "RESET_TIME",
  LANGUAGE: "LANGUAGE",
};
